import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PaylinkResponse } from 'skipify-types';
import dayjs from 'dayjs';

import { PaylinkDetails, PaylinkDetailsPage } from './index';
import { DialogCloseButton } from '../../../../components/core/DialogCloseButton';

interface Props {
  merchantName: string;
  merchantId: string;
  paylink: PaylinkResponse;
  isOpen: boolean;
  onClose: () => void;
  defaultOpenPage?: PaylinkDetailsPage;
}

/**
 * @summary Modal component to view paylink details
 * @param {Props} props Component properties
 * @returns {JSX.Element} paylink detail modal
 */
const DetailModal = ({
  isOpen,
  onClose,
  merchantName,
  paylink,
  merchantId,
  defaultOpenPage,
}: Props) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: 4, overflow: 'hidden' } }}
    >
      <DialogTitle
        sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1, alignItems: 'center' }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: 600, color: 'black' }}>Details</Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: 'grey.600',

            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          {dayjs(paylink.createdAt).format('M/D/YY h:mma')}
        </Typography>
      </DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent sx={{ p: 0, overflowX: 'hidden' }} dividers>
        <PaylinkDetails
          merchantId={merchantId}
          merchantName={merchantName}
          paylink={paylink}
          defaultOpenPage={defaultOpenPage}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DetailModal;
